import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import matter from "gray-matter";
import NavAndHero from "../components/NavAndHero";
import Footer from "../components/Footer";
import CallToAction from "../components/CTA";

import { Buffer } from 'buffer';
if (typeof window !== 'undefined' && !window.Buffer) {
  window.Buffer = Buffer;
}


const BlogPost = () => {
  const { slug } = useParams();
  const [content, setContent] = useState("");
  const [meta, setMeta] = useState({ title: "", date: "" });

  useEffect(() => {
    import(`./blog/${slug}.md`)
      .then((res) => fetch(res.default))
      .then((res) => res.text())
      .then((text) => {
        const { data, content } = matter(text);
        setMeta(data);
        setContent(content);
      })
      .catch((err) => {
        console.error("Error loading post:", err);
        setContent("# 404 - Post not found");
      });
  }, [slug]);

  return (
    <div data-theme="light">
      <NavAndHero />

      <section className="px-6 py-20 bg-base-100 min-h-screen">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-5xl md:text-5xl font-bold text-neutral mb-4 leading-tight">{meta.title}</h1>
          <p className="text-gray-400 mb-8">{meta.date}</p>

          <div className="prose prose-lg max-w-none text-gray-800">
            <ReactMarkdown>{content}</ReactMarkdown>
          </div>
        </div>
      </section>

      <div id='cta'>
        <CallToAction /> 
      </div>

      <Footer />
    </div>
  );
};

export default BlogPost;
